//@flow
import React, { useState } from 'react';
import { CallToAction } from 'components/atoms/callToAction';
import { PaginationControl } from 'components/molecules/paginationControl';
import HorizontalCarousel from 'components/molecules/horizontalCarousel';
import { useViewport } from 'components/templates/viewportProvider';
import { EventNotificationButton } from 'components/molecules/eventNotificationButton';
import { OverlayPortal } from 'components/templates/overlayPortal';
import { OverlayModal } from 'components/templates/overlayModal';
import './styles.scss';

type Props = {
  data: Object<dataPropTypes>,
};
export type dataPropTypes = {
  result_news_data: Object<newsDataProps>,
};
export type newsDataProps = {
  id: number,
  title: string,
  description: string,
  picture: string,
  mobile_picture: string,
  pdf_file?: any,
  pdf_path?: string,
  published_on: string,
  media_path_thumbnail: string,
  media_path_thumbnail_mobile: string,
};
export const AboutNews = (props: Props) => {
  const { result_news_data } = props.data;
  const {
    sectionHeading,
    overlayButtonText,
    showNotificationButton,
    breadcrumbList,
  } = props;
  const { height } = useViewport();
  const [sliderRef, setSlider] = useState(null);
  const [activeSlide, setActiveSlide] = useState(0);
  const [showDescriptionLayout, setShowDescriptionLayout] = useState(false);

  const handleSliderRef = ref => {
    setSlider(ref);
  };

  const next = () => {
    sliderRef.slickNext();
  };

  const previous = () => {
    sliderRef.slickPrev();
  };
  const showOverlay = showDescriptionLayout ? (
    <OverlayPortal>
      <OverlayModal
        data={result_news_data}
        theme={'dark-theme'}
        type={'news-publications-overlay'}
        onClosePress={() => setShowDescriptionLayout(false)}
        breadcrumbList={[
          {
            breadcrumbName: breadcrumbList[1].breadcrumbName,
            breadcrumbLink: '#',
          },
          {
            breadcrumbName: breadcrumbList[2].breadcrumbName,
            breadcrumbLink: '#',
          },
        ]}
      />
    </OverlayPortal>
  ) : null;

  const lengthOfSliders =
    result_news_data.length < 4 ? 1 : result_news_data.length - 2;
  return (
    <div className={'about-news-body section-container'} style={{ height }}>
      <div className={'section-header'}>
        <CallToAction
          text={overlayButtonText}
          onClick={() => setShowDescriptionLayout(true)}
          mode={'light'}
          className={'section-header-item'}
        />
      </div>
      <div className={'news-inner-section-body'}>
        <h1>{sectionHeading}</h1>
        {result_news_data ? (
          <HorizontalCarousel
            data={result_news_data}
            type={'newsCard'}
            cssFor={'newsCard'}
            getActiveSlide={e => {
              setActiveSlide(e);
            }}
            handleSliderRef={handleSliderRef}
          />
        ) : null}
      </div>
      <div className="section-footer">
        {showNotificationButton && (
          <EventNotificationButton
            className={''}
            theme={'dark-theme'}
            text={'GET NOTIFIED OF UPCOMING EVENTS'}
            link={'contact'}
          />
        )}
        <PaginationControl
          className={'section-footer-item'}
          theme={'dark-theme'}
          mode={'slider'}
          currentIndex={activeSlide + 1}
          total={lengthOfSliders}
          onNextClick={next}
          onPreviousClick={previous}
          key={'17'}
        />
      </div>
      {showOverlay}
    </div>
  );
};
